import React from 'react';
import { Box, Fade } from '@material-ui/core';
import { yellow } from 'globals/colors';
import defaultLocales from 'globals/locales/default';
import { UserRole } from 'globals/types';
import { useRole } from 'globals/hooks/useRole';
import FsHeaderSmall from 'ui-elements/typography/FsHeaderSmall';
import { ReactComponent as IntegrateWidget } from 'assets/images/dashboard/integrate-widget.svg';
import { ReactComponent as InviteCustomer } from 'assets/images/dashboard/invite-customer.svg';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import { WrapperBox } from './WelcomeDashboard.style-elements';
import SubBoard from './SubBoard';
import MainBoard from './MainBoard';

const {
  subBoards: subBoardsLocales,
  subTitle,
} = defaultLocales.welcomeDashboardPage;

const WelcomeDashboard: React.FC = () => {
  const isAccountant = useRole(UserRole.ACCOUNTANT);

  return (
    <Fade in timeout={1000}>
      <WrapperBox>
        <MainBoard />
        {!isAccountant && (
          <Box p={3}>
            <FsHeaderSmall>{subTitle}</FsHeaderSmall>
            <FsGridContainer>
              {subBoardsLocales.map(
                ({ title, description, buttonLabel, buttonUrl }, idx) => (
                  <FsGridItem xs={12} md={6} key={title}>
                    <SubBoard
                      title={title}
                      imageComponent={
                        idx === 0 ? <InviteCustomer /> : <IntegrateWidget />
                      }
                      backgroundColor={idx === 1 ? yellow.V1 : undefined}
                      buttonLabel={buttonLabel}
                      buttonUrl={buttonUrl}
                    >
                      {description}
                    </SubBoard>
                  </FsGridItem>
                )
              )}
            </FsGridContainer>
          </Box>
        )}
      </WrapperBox>
    </Fade>
  );
};

export default WelcomeDashboard;
